// src/components/Dashboard/ComprasChart.js
import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  LineElement, PointElement, Filler, Title, Tooltip, Legend
} from 'chart.js';
import { formatMoney, formatMoneyCorto } from '../../utils/formato';

// Registramos los componentes necesarios de Chart.js
ChartJS.register(
  CategoryScale, LinearScale, BarElement,
  LineElement, PointElement, Filler, Title, Tooltip, Legend
);

/**
 * Gráfico del dashboard. Sirve para barras y para líneas.
 *
 * @param {object} chartData - data de Chart.js ({ labels, datasets })
 * @param {string} title     - título mostrado arriba del gráfico
 * @param {'bar'|'line'} tipo
 * @param {boolean} horizontal - barras horizontales (útil con nombres largos)
 * @param {number} height    - alto en píxeles
 */
const ComprasChart = ({
  chartData,
  title = 'Compras',
  tipo = 'bar',
  horizontal = false,
  height = 400
}) => {

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: horizontal ? 'y' : 'x',
    plugins: {
      legend: { display: false },
      title: { display: true, text: title, font: { size: 16 } },
      tooltip: {
        callbacks: {
          // Los valores son importes: se muestran formateados en el tooltip.
          label: (ctx) => formatMoney(ctx.parsed[horizontal ? 'x' : 'y'])
        }
      }
    },
    scales: {
      x: {
        grid: { display: horizontal },
        // Con nombres de proveedor/artículo largos, se recortan para que entren.
        ticks: horizontal
          ? { callback: (v) => formatMoneyCorto(v) }
          : { callback(value) {
                const etiqueta = this.getLabelForValue(value);
                return etiqueta.length > 18 ? `${etiqueta.slice(0, 18)}…` : etiqueta;
              }
            }
      },
      y: {
        beginAtZero: true,
        ticks: horizontal ? {} : { callback: (v) => formatMoneyCorto(v) }
      }
    }
  };

  if (!chartData || !chartData.labels?.length) {
    return (
      <div className="d-flex align-items-center justify-content-center text-muted" style={{ height }}>
        <div className="text-center">
          <i className="bi bi-bar-chart fs-1 d-block mb-2 opacity-50"></i>
          Sin datos para el período seleccionado
        </div>
      </div>
    );
  }

  const Grafico = tipo === 'line' ? Line : Bar;

  return (
    <div style={{ height: `${height}px` }}>
      <Grafico data={chartData} options={options} />
    </div>
  );
};

export default ComprasChart;
